export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13 4a1 1 0 11-2 0 1 1 0 012 0zm3.95 3.05a.996.996 0 111.41-1.41.996.996 0 11-1.41 1.41zM12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm-7-3a1 1 0 11-2 0 1 1 0 012 0zm15 1a1 1 0 100-2 1 1 0 000 2zm-8 8a1 1 0 100-2 1 1 0 000 2zm4.95-2.64a.996.996 0 111.41-1.41.996.996 0 11-1.41 1.41zM5.64 16.95a.996.996 0 101.41 1.41.996.996 0 10-1.41-1.41zm1.41-9.9a.996.996 0 10-1.41-1.41.996.996 0 101.41 1.41z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};